<div class="table-wrap">
  <table>
    <thead><tr><th class="check"></th><th class="name">氏名</th><th>所属</th><th>役職</th><th>事前回答</th><th>当日実績</th></tr></thead>
    <tbody>
      @for (target of targets; track target.targetId) {
        <tr>
          <td class="check"><input type="checkbox" [disabled]="editingLocked" [attr.aria-label]="target.name + 'を選択'" [checked]="selected.has(target.targetId)" (change)="selection.emit({id:target.targetId,checked:$any($event.target).checked})"></td>
          <td class="name">{{ target.name }} @if (target.accountStatus !== 'active') { <small class="account-warning">{{ target.accountStatus === 'deleted' ? 'アカウント削除済み' : 'アカウント無効' }}<br>実績は保持されています。対象から外す場合は除外してください。</small> }</td>
          <td class="organization-path">{{ target.organizationPath || target.organization || '所属未設定' }}</td>
          <td class="role-name">{{ target.role }}</td>
          <td><span class="tag">{{ plannedLabel(target.plannedStatus) }}</span></td>
          <td>
            <select class="actual-select" [disabled]="editingLocked || !canUpdateActual" [attr.aria-label]="target.name + 'の当日実績'" [value]="target.actualStatus"
              (change)="actual.emit({target:target,next:$any($event.target).value,select:$any($event.target)})">
              <option value="not_checked_in">未登録</option>
              <option value="attended">出席</option>
              <option value="absent">欠席</option>
            </select>
          </td>
        </tr>
      } @empty {<tr><td colspan="6">条件に一致する対象者はいません。検索や絞り込みを変更してください。</td></tr>}
    </tbody>
  </table>
</div>
